(function () {
    function init() {
        const rows = document.querySelectorAll('table.nc-table tbody tr[data-primary-key]');

        rows.forEach((row) => {
            const btn = row.querySelector('td.row-actions a[href][title="compass.actions.show"]');

            if (!btn) {
                return;
            }

            const isDisabled = (el) => {
                return (
                    el.classList.contains('disabled') ||
                    el.hasAttribute('disabled') ||
                    el.getAttribute('aria-disabled') === 'true'
                );
            };

            if (isDisabled(btn)) {
                // Make the row darker gray to indicate it's disabled
                row.style.backgroundColor = '#e9ecef';
                row.style.color = '#6c757d';
                row.style.cursor = 'not-allowed';
                row.style.opacity = '0.6';
                return; // Skip adding click handler
            }

            // Prevent duplicate bindings if this script runs multiple times
            if (row.dataset.rowClickBound === '1') {
                return;
            }
            row.dataset.rowClickBound = '1';

            row.style.cursor = 'pointer';

            const handler = (event) => {
                // Check if button is disabled at click time
                if (isDisabled(btn)) {
                    event.preventDefault();
                    event.stopPropagation();
                    return false;
                }

                // Ignore interactions originating from interactive fields
                const interactive = 'a, input, select, textarea, button';
                if (event.target.closest(interactive)) {
                    return;
                }

                document.location = btn.getAttribute('href');
            };

            row.addEventListener('click', handler);
            row.addEventListener('keydown', handler);
        });
    }

    // Behave like jQuery's $(document).ready(): if DOM is already ready, run now; otherwise, wait.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
